export const retrieveAccountDetailsMigration = (state:any, version:number) => {  
    switch(version) {
        case (0): {
            return {      
                ...state.retrieveAccountDetails,        
				selectedBankIsUnavailable: false
            }  
        }
    }
} 